const ADMIN_EMAIL_DOMAIN = 'junzhu-admin.com';

/**
 * 后台用「账号 + 密码」登录，内部把账号转成 Supabase 认可的内部邮箱。
 * 输入里带 @ 时按真实邮箱处理，否则拼上内部域名。
 */
export function toLoginEmail(input: string): string {
  const value = input.trim();
  if (!value) return '';
  if (value.includes('@')) return value;
  return `${value.toLowerCase()}@${ADMIN_EMAIL_DOMAIN}`;
}

export function toAdminEmailTip(): string {
  return ADMIN_EMAIL_DOMAIN;
}